<ng-template #confirmAccount>
  <ng-container *transloco="let t">
  <div class="d-flex flex-column flex-column-fluid p-10 pb-lg-10 register-wrapper"
    [ngClass]="{'overlay': spinnerVisible, 'overlay-block': spinnerVisible}">

    <div class="w-md-500px bg-white rounded shadow-sm p-7 p-lg-7 register-body">
      <div class="d-flex justify-content-center mb-4">
        <logo [logoUrlsToTry]="possibleLogoUrls"></logo>
      </div>
      <form class="form" novalidate="novalidate" #createAccountForm="ngForm" id="createAccountForm"
        name="createAccountForm">
        <div class="text-center my-4">
          <h2 class="text-dark mb-3">{{ t('auth.confirmAccount.welcomeBack') }}</h2>
          @if (!alreadyRegistered) {
            <div class="text-gray-400 fw-bold fs-5">{{ t('auth.confirmAccount.setupPassword') }}
              {{userName}}
            </div>
          }
        </div>
        @if (alreadyRegistered) {
          <div class="alert alert-primary d-flex align-items-center p-5 mb-5">
            <span class="svg-icon svg-icon-2hx svg-icon-primary me-3">
              <duotone-shield-check-svg-icon></duotone-shield-check-svg-icon>
            </span>
            <div class="d-flex flex-column">
              <span>{{ t('auth.confirmAccount.alreadyRegisteredMessage') }}</span>
            </div>
          </div>
          <div class="text-center pb-lg-0 pb-8">
            <button type="button" class="btn btn-lg btn-primary fw-bolder" (click)="onGoToSignInClicked()">
              <span class="indicator-label">{{ t('auth.confirmAccount.goToSignIn') }}</span>
            </button>
          </div>
        } @else {
        @if (tokenConfirmed && !errorMessage) {
          <div class="alert alert-success d-flex align-items-center p-5 mb-5">
            <span class="svg-icon svg-icon-2hx svg-icon-success me-3">
              <duotone-shield-check-svg-icon></duotone-shield-check-svg-icon>
            </span>
            <div class="d-flex flex-column">
              <span>{{ t('auth.confirmAccount.confirmed') }}</span>
            </div>
          </div>
        }
        @if (errorMessage) {
          <div class="alert alert-danger d-flex align-items-center p-5 mb-5">
            <span class="svg-icon svg-icon-2hx svg-icon-danger me-3">
              <duotone-shield-check-svg-icon></duotone-shield-check-svg-icon>
            </span>
            <div class="d-flex flex-column login-error-body">
              <span>{{errorMessage}}</span>
            </div>
          </div>
        }
        <div class="fv-row mb-5">
          <label class="form-label fw-bolder text-dark fs-6">{{ t('auth.confirmAccount.email') }}</label>
          <input class="form-control form-control-solid" type="email" value="{{userName}}" placeholder="" readonly
            name="email" autocomplete="off" email trim />
        </div>
        <div class="mb-5 fv-row" data-kt-password-meter="true" #passwordSection>
          <div class="mb-1">
            <label class="form-label fw-bolder text-dark fs-6">{{ t('auth.resetPassword.password') }}</label>
            <div class="position-relative mb-3">
              <input [type]="passwordInputState.displayed ? 'text' : 'password'"
                class="form-control form-control-solid has-visibility-toggle" [(ngModel)]="password" autocomplete="off"
                placeholder="" id="password" name="password" reverse="true"
                required
                [minlength]="passwordPolicy?.minimumPasswordLength || 8"
                (mousedown)="op.show($event)"
                (ngModelChange)="onPasswordChanged()"
                (blur)="op.hide()"
                [ngClass]="{'is-invalid' : userPassword && userPassword.touched && userPassword.invalid}"
                #userPassword="ngModel" validateEqual="confirmedPassword" />
              <p-popover #op styleClass="password-validation-overlay">
                <ng-template pTemplate="content">
                  <div>
                    <div class="d-flex password-validation-indicator" [ngClass]="{
                        'text-success': passwordIsMinimum8Characters
                        }">
                      <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                          'fa-smile': passwordIsMinimum8Characters,
                          'text-success': passwordIsMinimum8Characters
                          }"></i>
                      <div>{{ t('auth.resetPassword.minChars') }}</div>
                    </div>
                    @if (!passwordPolicy || passwordPolicy.requireDigit) {
                    <div class="d-flex password-validation-indicator" [ngClass]="{
                        'text-success': passwordContainsDigit
                        }">
                      <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                          'fa-smile': passwordContainsDigit,
                          'text-success': passwordContainsDigit
                          }"></i>
                      <div>{{ t('auth.resetPassword.includeNumber') }}</div>
                    </div>
                    }
                    @if (!passwordPolicy || passwordPolicy.requireLowercase) {
                    <div class="d-flex password-validation-indicator" [ngClass]="{
                      'text-success': passwordContainsLowercase
                      }">
                      <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                        'fa-smile': passwordContainsLowercase,
                        'text-success': passwordContainsLowercase
                        }"></i>
                      <div>{{ t('auth.resetPassword.includeLowercase') }}</div>
                    </div>
                    }
                    @if (!passwordPolicy || passwordPolicy.requireUppercase) {
                    <div class="d-flex password-validation-indicator" [ngClass]="{
                    'text-success': passwordContainsUppercase
                    }">
                      <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                      'fa-smile': passwordContainsUppercase,
                      'text-success': passwordContainsUppercase
                      }"></i>
                      <div>{{ t('auth.resetPassword.includeUppercase') }}</div>
                    </div>
                    }
                    @if (!passwordPolicy || passwordPolicy.requireSpecialCharacter) {
                    <div class="d-flex password-validation-indicator" [ngClass]="{
                      'text-success': passwordContainsSpecialCharacter
                      }">
                        <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                        'fa-smile': passwordContainsSpecialCharacter,
                        'text-success': passwordContainsSpecialCharacter
                        }"></i>
                        <div>{{ t('auth.resetPassword.includeSpecial') }}</div>
                      </div>
                    }
                  </div>

                </ng-template>
              </p-popover>
              <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                @if (!passwordInputState.displayed) {
                  <i class="bi bi-eye-slash fs-2 password-visibility-icon"
                    (click)="onPasswordStateClicked(passwordInputState)"
                    (touchend)="onPasswordStateClicked(passwordInputState)"></i>
                }
                @if (passwordInputState.displayed) {
                  <i class="bi bi-eye fs-2 password-visibility-icon"
                    (click)="onPasswordStateClicked(passwordInputState)"
                    (touchend)="onPasswordStateClicked(passwordInputState)"></i>
                }
              </span>
            </div>
            @if (userPassword.touched && userPassword.errors && userPassword.errors.required) {
              <div class="invalid-feedback d-block">{{ t('auth.resetPassword.enterPassword') }}</div>
            }
            @if (userPassword.touched && userPassword.errors && userPassword.errors.validateEqual) {
              <div class="invalid-feedback d-block">{{ t('auth.resetPassword.passwordMismatch') }}</div>
            }
            <div class="d-flex align-items-center mb-3" data-kt-password-meter-control="highlight">
              <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
              <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
              <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
              <div class="flex-grow-1 bg-secondary bg-active-success rounded h-5px"></div>
            </div>
          </div>
          <div class="text-muted">{{ t('auth.confirmAccount.passwordHint') }}</div>
        </div>
        <div class="fv-row mb-5">
          <label class="form-label fw-bolder text-dark fs-6">{{ t('auth.resetPassword.confirmPassword') }}</label>
          <div class="position-relative">
            <input [type]="confirmPasswordInputState.displayed ? 'text' : 'password'"
              class="form-control form-control-solid has-visibility-toggle" [(ngModel)]="confirmedPassword"
              autocomplete="off" required placeholder="" name="confirmedPassword"
              [ngClass]="{'is-invalid' : userConfirmedPassword && userConfirmedPassword.touched && userConfirmedPassword.invalid}"
              #userConfirmedPassword="ngModel" validateEqual="password" />
            <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
              @if (!confirmPasswordInputState.displayed) {
                <i class="bi bi-eye-slash fs-2 password-visibility-icon"
                  (click)="onPasswordStateClicked(confirmPasswordInputState)"
                  (touchend)="onPasswordStateClicked(confirmPasswordInputState)"></i>
              }
              @if (confirmPasswordInputState.displayed) {
                <i class="bi bi-eye fs-2 password-visibility-icon"
                  (click)="onPasswordStateClicked(confirmPasswordInputState)"
                  (touchend)="onPasswordStateClicked(confirmPasswordInputState)"></i>
              }
            </span>
          </div>
          @if (userConfirmedPassword.touched && userConfirmedPassword.errors && userConfirmedPassword.errors.required) {
            <div class="invalid-feedback d-block">
              {{ t('auth.resetPassword.confirmPasswordPlaceholder') }}</div>
          }
          @if (userConfirmedPassword.touched && userConfirmedPassword.errors && userConfirmedPassword.errors.validateEqual) {
            <div class="invalid-feedback d-block">
              {{ t('auth.resetPassword.passwordMismatch') }}</div>
          }
        </div>
        <div class="fv-row mb-10">
          <label class="form-check form-check-custom form-check-solid form-check-inline mb-5">
            <input class="form-check-input" type="checkbox" name="toc" [(ngModel)]="tocAccepted" />
            <span class="form-check-label fw-bold text-gray-700">
              <a (click)="onTermsAndConditionsClicked()" class="link-primary ms-1">{{ t('auth.confirmAccount.termsAndConditions') }}</a>.</span>
          </label>
        </div>
        <div class="text-center pb-lg-0 pb-8">
          <button type="button" [disabled]="!tocAccepted" class="btn btn-lg btn-primary fw-bolder"
            (click)="onCreatePasswordClicked()">
            <span class="indicator-label">{{ gotoPortalScope ? t('auth.confirmAccount.createAndGoToPortal') : t('auth.confirmAccount.createAndContinue') }} </span>
            @if (!spinnerVisible) {
              <span class="svg-icon svg-icon-4 ms-1 me-0">
                <duotone-navigation-right-svg-icon></duotone-navigation-right-svg-icon>
              </span>
            }
            @if (spinnerVisible) {
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            }
          </button>
        </div>
        }
      </form>
      <div class="overlay-layer rounded bg-primary-o-20">
        <div class="spinner spinner-primary"></div>
      </div>

    </div>
  </div>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="login-footer">
      <img src="https://borrowerportal.lodasoft.dev/assets/img/Logo.svg" alt="Lodasoft">
    </div>
  </div>
  </ng-container>

</ng-template>

<user-account-template [contentTemplate]="confirmAccount"></user-account-template>
